import { Injectable } from '@angular/core';
import {SclMapConstantService} from './scl-map-constant.service';
import { cloneDeep } from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class SclMapGeoVicmapService {

  constructor() {
  }

  autocompleteUrl = 'https://api.maps.vic.gov.au/vicmapapi/map/addressSearch?jsoncallback=data&format=json&addressLine=';
  geocodeUrl = 'https://www.geocode.farm/v3/json/reverse/';
  apiKeyReverse = 'a2338e05-e3cb425e93ad-109049bfb516'; // temprature use of geocodefarm
  geocoderDefaultCountry = 'Australia';
  geocoderDefaultState = 'VIC';
  autocompleteBox;
  waitTime = 5000; // miliseconds
  apiKey;
  country;
  language;
  initObj;
  autocompleteStreet;

  reverse( coor, cb, cbErr, cbTimeout) {
    let link = this.geocodeUrl + '?lat=' + coor[1] + '&lon=' + coor[0] + '&key=' + this.apiKeyReverse + '&count=1';
    link = this.getLinkOptions( link);
    this.initObj.httpService.getAPI(link, {timeout: this.waitTime})
      .subscribe( data => {
          if (data && data.geocoding_results.STATUS.status === 'SUCCESS') {
            const suggestions = data.geocoding_results.RESULTS[0];
            const address = suggestions.ADDRESS;
            const streetData: any = cloneDeep(SclMapConstantService.STREET);
            streetData.properties.streetNo = address.street_number;
            streetData.properties.street = address.street_name;
            streetData.properties.suburb = address.locality;
            streetData.properties.postcode = address.postal_code;
            streetData.properties.country = address.country;
            streetData.properties.state = address.admin_1;
            streetData.geometry.coordinates[0] = coor[0]; // lon
            streetData.geometry.coordinates[1] = coor[1]; // lat
            if (cb && typeof cb === 'function') {
              cb(streetData, { lat: parseFloat(suggestions.COORDINATES.latitude) , lng: parseFloat(suggestions.COORDINATES.longitude) });
            }
          } else {
            if (cbErr && typeof cbErr === 'function') {
              cbErr('Vicmap reverse Error');
            }
          }

        },
        err => {
          if (err.status === -1) {
            if (cbTimeout && typeof cbTimeout === 'function') {
              cbTimeout();
            }
          } else {
            if (cbErr && typeof cbErr === 'function') {
              cbErr('Vicmap reverse Error');
            }
          }
        });
  }
  lookUp( params, cb, cbErr, cbSelectOption, cbRemoveStreet, cbTimeout ) {
    if (params == null || params.length < 1) {
      if (cbErr && typeof cbErr === 'function') {
        cbErr('params is invalid, [0] : autocompleteBox');
      }
      return;
    }
    if (this.autocompleteBox == null) {
      this.autocompleteBox = params[0];
    }


    if (params.length > 1) {
      this.search(params[1], cb, cbErr, cbTimeout);
    }
  }
  removeLookUpfunction() {
    const id = this.initObj.keyName + 'MapGeoVicmap';
    const lst = document.querySelectorAll('#' + id);
    if (lst && lst.length > 0) {
      for (let i = 0; i < lst.length; i++) {
        lst[i].remove();
      }
    }
    this.autocompleteBox = null;
  }
  removeStreet(cb) {
    if (this.autocompleteStreet == null) {
      this.autocompleteStreet = document.getElementById(this.initObj.keyName + 'autocomplete');
    }
    if (this.autocompleteStreet == null) {
      if (cb && typeof cb === 'function') {
        cb();
      }
      return;
    }
    this.autocompleteStreet.value = '';

    if (cb && typeof cb === 'function') {
      cb();
    }
  }
  search(sPartialAddress, cb, cbErr, cbTimeout) {
    if ( sPartialAddress == null ) {
      if (cbErr && typeof cbErr === 'function') {
        cbErr('vicmap address lookup: text is null');
      }
      return;
    }
    if ( sPartialAddress.trim().length < 3 ) {
      if (cbErr && typeof cbErr === 'function') {
        cbErr('vicmap address lookup: text is less than 3 characters');
      }
      return;
    }

    const link = this.autocompleteUrl + sPartialAddress.trim() + ', ' + this.geocoderDefaultState + ', ' + this.geocoderDefaultCountry;
    const options =  {
      responseType: 'text',
      timeout: this.waitTime
    };
    const httpClient = this.initObj.httpService.getHttpClient();
    httpClient.get(link, options)
      .subscribe( (addressResponse: any) => {
          // addressResponse is string
          if (addressResponse == null) {
            if (cbErr && typeof cbErr === 'function') {
              cbErr('null data');
            }
            return;
          }
          addressResponse = addressResponse.replace('?(', ''); // remove ?(
          addressResponse = addressResponse.substring(0, addressResponse.length - 2); // remove );

          const results = JSON.parse(addressResponse);
          const result = results.requestResult.result;
          if (result) {

            const results1 = [];
            for (let k = 0; k < result.length; k++) {
              const r = result[k];
              const p = r.address;
              for (let f = 0; f < p.length; f++) {
                const address = p[f];
                const sugg: any = {};
                sugg.street = address.addressLine;

                const res = address.pos[0].split(',');
                sugg.coordinates = {};
                sugg.coordinates.latitude = res[0];
                sugg.coordinates.longitude = res[1];

                sugg.address = {};
                if (address.unitNumberPrefix) {
                  sugg.address.unitNo = address.unitNumberPrefix;
                  sugg.address.unitNo += address.unitNumber;
                } else { sugg.address.unitNo = address.unitNumber; }
                sugg.address.street_number = address.thoroughfareNumberFrom;
                sugg.address.street_name = '';
                if (address.thoroughfareName) { sugg.address.street_name = address.thoroughfareName; }
                if (address.thoroughfareTrailingType) { sugg.address.street_name += ' ' + address.thoroughfareTrailingType; }
                sugg.address.locality = address.locality;
                sugg.address.postal_code = address.postcode;
                if (!address.country) { sugg.address.country = 'Australia'; }
                sugg.address.admin_1 = address.state;

                results1.push(sugg);
              }
            }
            if (results1.length > 0) {
              if (cb && typeof cb === 'function') {
                cb(results1);
              }
            } else {
              if (cbErr && typeof cbErr === 'function') {
                cbErr('Vicmap lookup Error ');
              }
            }
          } else {
            // logger.error("search vicmap error");
            if (cbErr && typeof cbErr === 'function') {
              cbErr('search vicmap no data');
            }
          }
        },
        err => {
          console.log(err);
          if (err.status === -1) {
            if (cbTimeout && typeof cbTimeout === 'function') {
              cbTimeout();
            }
          } else {
            //// logger.info(err);
            if (cbErr && typeof cbErr === 'function') {
              cbErr('Vicmap lookup Error ');
            }
          }
        });
  }

  selectionOption(tpl, model, cb) {
    const address = tpl.address; const coordinates = tpl.coordinates;
    const obj: any = cloneDeep(SclMapConstantService.STREET);
    // { properties: {}, geometry: { coordinates: [] } };
    if (address.unitNo) {obj.properties.unitNo = address.unitNo; }

    obj.properties.streetNo = address.street_number;
    obj.properties.street = address.street_name;
    obj.properties.suburb = address.locality;
    obj.properties.postcode = address.postal_code;
    obj.properties.country = address.country;
    obj.properties.state = address.admin_1;

    // let coordinates = tpl.coordinates;
    const lat = parseFloat(coordinates.latitude);
    const lon = parseFloat(coordinates.longitude);
    obj.geometry.coordinates[0] = lon;
    obj.geometry.coordinates[1] = lat;

    if (cb && typeof cb === 'function') {
      cb(obj);
    }
  }
  getLinkOptions( link) {
    if (this.country) { link += '&country=' + this.country; }
    if (this.language) { link += '&lang=' + this.language; }

    return link;
  }

}
